module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The B Word")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the long gestation of this project, I have benefitted from the insights and support of many advisers, colleagues, friends, and family. I especially wish to thank my UCLA dissertation committee, Denise Mann, Kathleen McHugh, Jim Schultz, and especially my chair, Janet Bergstrom, as well as the other mentors who have guided and advocated for me and become friends in the process: Laura Mulvey, Vivian Sobchack, Wini Wood, and the warm, wise women of WGS at Harvard. My gratitude goes out to Tania Modleski for offering her assurance of my project’s potential, and to Jane Behnken for first showing interest in my manuscript and for shepherding it along. Jane’s colleagues at Indiana University Press, especially Peter Froehlich, Darja Malcolm-Clarke, Raina Polivka, Sarah Wyatt Swanson, and Jenna Whittaker, have provided invaluable support along the way, and Eric Levy proved an outstanding copyeditor in the final act. My undergraduate alma mater and postgraduate home, Wellesley College, and its passionate, talented teachers and students, are an ongoing source of creative revelation and intellectual stimulation for me. My UCLA classmates and friends Ross Melnick, Jennifer Moorman, Maya Montañez Smukler, and Laurel Westrup have contributed a decade’s worth of personal and professional celebration and commiseration, for which I’m eternally grateful. Candace Moore has been an inspiration as a thinker and writer, and in so many other ways. My parents Frank and D San Filippo, my sister Kristina San Filippo, and my “sister” Ivey Doyal Rucket are all immeasurably part of who I am and what I’ve done, for which I’m forever in their debt. Above all, I wish to thank Vernon Shetley – my unflagging "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("mentor, my most discerning editor, my favorite fellow cinéaste, and “the best and loyalist friend a girl ever had.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209422b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0